import { ENVIRONMENT } from "@/base/environment"
import type { CodaDeviceAliasProps } from "@/redux/models"

export const GRAFANA_BASE_URL =
  "https://admin.farmhq.com/grafana/d/1brB3XZVk/device-dashboard?orgId=1"
export function getGrafanaUrlForDevice(params: CodaDeviceAliasProps) {
  return `${GRAFANA_BASE_URL}&var-device_name=${params.codaDeviceAlias}&var-Environment=${ENVIRONMENT.targetDatabaseName}`
}
export const GRAFANA_BASE_DASHBOARDS_URL = "https://admin.farmhq.com/grafana/dashboards"
